import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

import Breadcrumbs from '../Breadcrumbs';

const BreadcrumbsBlock = ({ breadcrumbItems }) => (
  <Breadcrumbs
    items={
      breadcrumbItems.map(({ title, url }, index) => {
        const isLastItem = index === breadcrumbItems.length - 1;

        return {
          title,
          url: isLastItem ? null : url,
          current: isLastItem
        };
      })
    }
  />
);

Breadcrumbs.propTypes = {
  breadcrumbItems: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string
    })
  )
};

export const query = graphql`
  fragment BreadcrumbsBlockFragment on ContentfulBreadcrumbs {
    __typename
    breadcrumbItems {
      title
      url
    }
    personalizations {
      ...PersonalizationFragment
    }
  }
`;

export default BreadcrumbsBlock;
